import { Link } from "react-router-dom";
import { IList } from "../../../utils/generalType";
import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";
import MotionCompGeneral from "./Motion_Comp";
import Slide from "react-reveal/Slide";
import { jobs } from "./Services/service.utils";

const jobLists: IList[] = jobs;

export const JobsCard = () => {
  return (
    <>
      {/* Our Service Slide */}
      <Slide up>
        <div className="text-center py-12 fontJostRegular">
          <div className="container mx-auto px-4">
            <MotionCompGeneral
              showMoveLeft={true}
              showMoveRight={true}
              showRotateLeft={true}
              moveRightImg={`${process.env.PUBLIC_URL + "/images/homePage/img-2-1.png"
                }`}
            />
            <p className="text-lg font-normal mb-4">
              Explore our diverse portfolio showcasing successful public
              relations campaigns, digital communication strategies, and
              impactful storytelling. Each project reflects our commitment to
              excellence and innovation.
            </p>
          </div>
        </div>
      </Slide>
      {/* Our Service Slide */}

      {/* Service Slide */}
      <div className=" text-white text-center py-12">
        <MotionCompGeneral showMoveLeft={true} showMoveRight={true} />
        <div className="container mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
          {jobLists.map((item: IList, index: number) => (
            <Slide bottom delay={index * 20} key={index}>
              <div className="p-2">
                <div className="rounded-lg  bg-white text-black text-left shadow hover:shadow-lg">
                  <img
                    className="rounded-xl mx-auto mb-4 object-cover"
                    src={item.image}
                    alt="service"
                    style={{
                      width: "100%",
                      height: "250px",
                    }}
                  />{" "}
                  <div className="p-4">
                    <h4 className="text-xl fontJostBold mb-2">{item.title}</h4>
                    <p className="mb-2">{item.caption}...</p>
                    <Link
                      to={"/ourjobs/" + (Number(index) + 1) + "/" + item.title}
                      className="inline-block w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl text-center transition"
                    >
                      About Job
                    </Link>
                  </div>
                </div>
              </div>
            </Slide>
          ))}
        </div>
      </div>
      {/* Service Slide */}
    </>
  );
};

export default JobsCard;
